import { useNavigate } from "react-router-dom";
import { FaSearch, FaEye } from "react-icons/fa";

export default function AllPendingInvoicesTable() {
    const navigate = useNavigate();

    const handleNavigate = (invoiceno) => {
        navigate(`/${invoiceno}`);
    };

    const data = [
        { id: 1, invoiceno: "1111", invoicedate: "Wed 20 May 2022 ", status: "Sucess", amount: "$2000" },
        { id: 2, invoiceno: "2222", invoicedate: "Fri 22 May 2022 ", status: "Sucess", amount: "$2000" },
    ];

    return (
        <div className="customer-container">
            <div className="special-header panel-white-all">
                <h4 className="page-title">Customer All Invoices</h4>
            </div>

            <div className="yc-list-body">
                <div className="yc-list-filter">
                    <div className="ff-search-wrap">
                        <FaSearch className="ff-search-icon" />
                        <input
                            type="text"
                            className="form-control ff-search-input"
                            placeholder="Invoice No"
                        />
                    </div>

                    <div className="ff-search-wrap">
                        <FaSearch className="ff-search-icon" />
                        <input
                            type="text"
                            className="form-control ff-search-input"
                            placeholder="Status"
                        />
                    </div>

                    <button type="button" className="btn btn-primary">Clear</button>
                </div>

                {/* Column Header */}
                <div className="yc-list-thead-card">
                    <div className="yc-list-grid yc-list-grid-6">
                        <div className="yc-list-cell">Sr No</div>
                        <div className="yc-list-cell">Invoice No</div>
                        <div className="yc-list-cell">Invoice Date</div>
                        <div className="yc-list-cell">Amount</div>
                        <div className="yc-list-cell">Status</div>
                        <div className="yc-list-cell">Action</div>
                    </div>
                </div>

                {/* Rows */}
                <div className="yc-list-row-list">
                    {data.map((row) => (
                        <div key={row.id} className="yc-list-row-card">
                            <div className="yc-list-grid yc-list-grid-6">
                                <div className="yc-list-cell">{row.id}</div>
                                <div className="yc-list-cell">{row.invoiceno}</div>
                                <div className="yc-list-cell">{row.invoicedate}</div>
                                <div className="yc-list-cell">{row.amount}</div>
                                <div className="yc-list-cell">{row.status}</div>
                                <div className="yc-list-cell yc-list-cell-actions">
                                    <button
                                        type="button"
                                        className="yc-action-icon"
                                        onClick={() => handleNavigate(row.invoiceno)}
                                        title="View"
                                    >
                                        <FaEye />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
